import { getMockPolicies } from "../builders/getMockPolicies";
import { omniUsSecondGearMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const patrickMahomes: MockPersona = {
  key: "patrickMahomes",
  name: "Patrick Mahomes",
  description: "🇺🇸 | State Farm policy | HDC 1.5 Single-tier | No Bills | Email Verified",
  partner: "state-farm",
  emailVerified: true,
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: getMockPolicies("0193845SCP01-00"),
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "pmahomes@statefarm.com",
            firstName: "Patrick",
            middleName: "",
            lastName: "Mahomes",
            mailingAddress: {
              line1: "300 NE 50TH CT",
              line2: "APT 203",
              city: "Kansas City",
              state: "MO",
              postalCode: "64118-4527",
              country: "USA",
            },
            preferredPhone: "8165023422",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: "STFRM",
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000024",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "STFRM123",
                partnerId: "STFRM",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: omniUsSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
